import React, { useEffect, useMemo, useState } from "react";

import {
  useActualPlaceholder,
  useDisplayedPlaceholders,
  useMap,
  usePlaceholders,
} from "Utils/hooks";
import markerIcons from "./icons.json";
import {
  ColorPickerComponent,
  DurationInput,
  IconConfig,
  ModelSelector,
  NameInput,
  ParentSelector,
  PathwayConfig,
  RotationSlider,
  ScaleSlider,
  TextIconInput,
  TypeSelector,
} from "./MarkerConfigComponents";

const MarkerConfig = ({ data }) => {
  const {
    setColor,
    setName,
    setType,
    setMarkerIcon,
    setScale,
    setRotation,
    setModel,
    setMarkerIconColor,
    setDuration,
    patchData,
    patchTitle,
    setIconText,
  } = useActualPlaceholder(data?.parentId);

  const { placeholders, changeParent } = usePlaceholders();
  const { clearFilters } = useDisplayedPlaceholders();
  const { isLeaflet } = useMap();
  const [color, setColorPicker] = useState(data?.marker?.color);
  const [scale, setScaleSlider] = useState(data?.marker?.scale ?? 1);
  const [rotation, setRotationSlider] = useState(data?.marker?.rotation ?? 0);

  const markersModels = ["pin", "basic", "flag", "tree"];

  //met à jour les parentId et tableaux de children
  const handleParentChange = (e) => {
    const parentId = e.target.value;
    if (data?.parentId) {
      changeParent(
        data?.id,
        data?.parentId,
        parentId === "none" ? null : parentId
      );
    } else {
      changeParent(data?.id, null, parentId);
    }
    clearFilters();
  };

  //set les valeurs par défaut
  useEffect(() => {
    setColorPicker(data?.marker?.color ?? window.__CONFIG__.theme.primaryColor);
    setScaleSlider(data?.marker?.scale ?? 1);
    setRotationSlider(data?.marker?.rotation ?? 0);
  }, [data?.id]);

  //set la liste des icons 2D
  const { projectId } = window?.__CONFIG__;
  const icons = useMemo(
    () => [...markerIcons.base, ...(markerIcons?.[projectId] ?? [])],
    [projectId]
  );

  // const handleDuration = (e) => {
  //   const dur = e.target.value;
  //   setDurationInput(dur);
  //   if (!dur) {
  //     setDuration(null);
  //   } else {
  //     const secs = stringToSeconds(dur);
  //     setDuration(secs);
  //   }
  // };

  return (
    <>
      <NameInput data={data} patchTitle={patchTitle} />

      {data?.children?.length > 0 ? (
        isLeaflet ? (
          <PathwayConfig data={data} patchData={patchData} />
        ) : (
          <DurationInput data={data} setDuration={setDuration} />
        )
      ) : (
        <ParentSelector
          data={data}
          placeholders={placeholders}
          handleParentChange={handleParentChange}
        />
      )}

      {!isLeaflet && (
        <TypeSelector isLeaflet={isLeaflet} data={data} setType={setType} />
      )}

      <ColorPickerComponent
        color={color}
        setColor={setColor}
        isDisableAlpha={data?.marker?.type === "3D"}
      />

      {data?.marker?.type === "2D" || isLeaflet ? (
        <>
          <TextIconInput
            data={data}
            isLeaflet={isLeaflet}
            setIconText={setIconText}
          />
          {!data?.marker?.iconText?.length ? (
            <IconConfig
              data={data}
              icons={icons}
              setMarkerIcon={setMarkerIcon}
              setMarkerIconColor={setMarkerIconColor}
            />
          ) : null}
        </>
      ) : (
        <ModelSelector
          data={data}
          markersModels={markersModels}
          setModel={setModel}
        />
      )}

      <ScaleSlider
        scale={scale}
        setScaleSlider={setScaleSlider}
        setScale={setScale}
      />

      {data?.marker?.type === "3D" && (
        <RotationSlider
          rotation={rotation}
          setRotationSlider={setRotationSlider}
          setRotation={setRotation}
        />
      )}
    </>
  );
};

export default MarkerConfig;
